import { render, staticRenderFns } from "./integralSetting.vue?vue&type=template&id=0dbc487e&scoped=true&"
import script from "./integralSetting.vue?vue&type=script&lang=js&"
export * from "./integralSetting.vue?vue&type=script&lang=js&"
import style0 from "./integralSetting.vue?vue&type=style&index=0&id=0dbc487e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc487e",
  null
  
)

export default component.exports